import console from './console-compat'
import {uuid} from "@/assets/plugins/mps-common/app/uuid";

export default {
    install(Vue) {
        // Vue.prototype.$alert = (message) => window.alert(message);
        Vue.prototype.$console = console;
        Vue.prototype.$uuid = () => uuid();
    }
}
